<template>
  <div class="Nav">
    <!--     nav    PC  -->
    <div class="nav_logo clearfix">
      <div class="l">
        <img :src="$route.path == '/' ? require('../../public/img/logo.png') : require('../../public/img/logo1.png') " alt="">
      </div>
      <div class="r" style="">
        <ul>
          <li :class="$route.path == '/' ? 'active' : ''" ><a href="javascript:;" @click="JumpToPage('')">首页</a></li>
          <li style="position: relative;" class="showDropMenu"  :class="$route.path != '/' ? 'active' : ''" >
            <a href="javascript:;">产品功能</a>
            <ul class="DropDownMenu">
              <li :class="$route.path == '/InsideCompany' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('InsideCompany')">我在企业</a></li>
              <li :class="$route.path == '/CompanyPanel' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('CompanyPanel')">企业面板</a></li>
              <li :class="$route.path == '/SalesBusiness' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('SalesBusiness')">销售业务</a></li>
              <li :class="$route.path == '/ProjectStart' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('ProjectStart')">项目实施</a></li>
              <li :class="$route.path == '/Purchase' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('Purchase')">企业采购</a></li>
              <li :class="$route.path == '/CompanyStock' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('CompanyStock')">企业仓库</a></li>
              <li :class="$route.path == '/CompanySetting' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('CompanySetting')">企业设置</a></li>
              <li :class="$route.path == '/WeChatApply' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('WeChatApply')">微信应用</a></li>

              <!--<li :class="$route.path == '/ReleaseContent' ? 'active' : ''"><a href="javascript:;" @click="JumpToPage('ReleaseContent')">发布内容</a></li>-->
            </ul>
          </li>
          <!--<li><a href="#">关于我们</a></li>-->
          <li class="IsLogin"><a target="_blank" href="http://www.teamrobotics.net/project">登录</a></li>
        </ul>
      </div>
    </div>
    <!--     nav    MOBILE  -->
    <div class="MobileMenu">
      <svg class="Zi Zi--More" fill="white" viewBox="0 0 24 24" width="30" height="30"><path d="M3.5 5h16a1.5 1.5 0 0 1 0 3h-16a1.5 1.5 0 0 1 0-3zm0 6h16a1.5 1.5 0 0 1 0 3h-16a1.5 1.5 0 0 1 0-3zm0 6h16a1.5 1.5 0 0 1 0 3h-16a1.5 1.5 0 0 1 0-3z" fill-rule="evenodd"></path></svg>
    </div>
    <div class="MobileMenuDown">
      <ul class="">
        <li :class="$route.path == '/' ? 'on' : ''" ><a href="javascript:;" @click="JumpToPage('')">首页</a></li>
        <li :class="$route.path == '/InsideCompany' ? 'on' : ''" ><a href="javascript:;" @click="JumpToPage('InsideCompany')">我在企业</a></li>
        <li :class="$route.path == '/CompanyPanel' ? 'on' : ''"><a href="javascript:;" @click="JumpToPage('CompanyPanel')">企业面板</a></li>
        <li :class="$route.path == '/SalesBusiness' ? 'on' : ''"><a href="javascript:;" @click="JumpToPage('SalesBusiness')">销售业务</a></li>
        <li :class="$route.path == '/ProjectStart' ? 'on' : ''"><a href="javascript:;" @click="JumpToPage('ProjectStart')">项目实施</a></li>
        <li :class="$route.path == '/Purchase' ? 'on' : ''"><a href="javascript:;" @click="JumpToPage('Purchase')">企业采购</a></li>
        <li :class="$route.path == '/CompanyStock' ? 'on' : ''"><a href="javascript:;" @click="JumpToPage('CompanyStock')">企业仓库</a></li>
        <li :class="$route.path == '/CompanySetting' ? 'on' : ''"><a href="javascript:;" @click="JumpToPage('CompanySetting')">企业设置</a></li>
        <li :class="$route.path == '/WeChatApply' ? 'on' : ''"><a href="javascript:;" @click="JumpToPage('WeChatApply')">微信应用</a></li>
      </ul>
    </div>
    <!--遮罩层-->
    <div class="model"></div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: [],
  methods:{
    JumpToPage(url){
      if(this.$route.path === '/'+url){
        return;
      }else{
        this.$router.push({
          path:"/" + url
        })
      }
    },
  },
  mounted(){
    $(".MobileMenu").click(function(){
      $(".MobileMenuDown").slideDown(350);
      $(".model").slideDown(350);
    });
    $(".model").click(function(){
      $(".MobileMenuDown").slideUp(350);
      $(".model").slideUp(350);
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  /*.nav_logo{*/
    /*position: fixed;*/
    /*top:0;*/
    /*left:0;*/
    /*height:75px;*/
    /*line-height: 95px;*/
    /*transition: all 0.3s;*/
  /*}*/
  /*.nav_logo_bg{*/
    /*background: rgba(0,0,0,.5);*/
  /*}*/
</style>
